import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./createaccount.css";
import CoverPhoto from "../../../Assets/Images/login_img1.png";
import NavbarCustom from "../../../Components/NavbarCustom";
import { ParentContext } from "../../../APIContext/ParentContext";
import Swal from "sweetalert2";
import SEO from "../../../Components/SEO";

const CreateAccount = () => {
  const { addParent } = useContext(ParentContext);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    password: "",
    phone: "",
    confirmPassword: "",
    is_self_pay: true,
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    if (!formData.first_name.trim()) return "Please enter First Name.";
    if (!formData.last_name.trim()) return "Please enter Last Name.";
    if (!formData.username.trim()) return "Please enter a Username.";
    if (!formData.email.trim()) return "Please enter your Email.";
    if (!formData.password.trim()) return "Please enter your Password.";
    if (!formData.phone.trim()) return "Please enter your Phone number.";
    if (formData.password !== formData.confirmPassword)
      return "Passwords do not match.";
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const validationError = validateForm();
    if (validationError) {
      setLoading(false);
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: validationError,
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
      return;
    }

    const payload = { ...formData };
    delete payload.confirmPassword;

    // console.log(payload);

    const result = await addParent(payload);

    if (result?.success) {
      Swal.fire({
        icon: "success",
        title: "Account Created Successfully",
        text: "Welcome!",
        timer: 1500,
        showConfirmButton: false,
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      }).then(() => {
        // navigate("/login");
        // console.log("Account created, you can now log in.", result.data);
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Failed to create your account!",
        text: result?.message || "Invalid input or server error.",
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
    }

    setLoading(false);
  };

  return (
    <>
      <SEO
        title="BWC Sports | Create Account"
        description=""
        url="https://bwcsports.com/create-an-account"
      />
      <NavbarCustom />
      <div className="login-container">
        <div className="login-form-con">
          <div className="login-form-ca">
            <h2>Create Your Account</h2>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <div>
                  <input
                    type="text"
                    name="first_name"
                    placeholder="First Name"
                    value={formData.first_name}
                    onChange={handleChange}
                  />

                  <input
                    type="text"
                    name="last_name"
                    placeholder="Last Name"
                    value={formData.last_name}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <div>
                  <input
                    type="text"
                    name="username"
                    placeholder="Username"
                    value={formData.username}
                    onChange={handleChange}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone number"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={formData.phone}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9+\s]/g, "");
                    setFormData((prev) => ({ ...prev, phone: value }));
                  }}
                />
              </div>

              <div className="form-group">
                <input
                  type="password"
                  name="password"
                  placeholder="Set Your Password"
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <input
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm Your Password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group radio-buttons">
                <div>
                  <label className="black-text-clip">
                    <input
                      type="radio"
                      name="is_self_pay"
                      value="true"
                      checked={formData.is_self_pay === true}
                      onChange={() =>
                        setFormData((prev) => ({ ...prev, is_self_pay: true }))
                      }
                    />
                    Self Pay
                  </label>

                  <label className="black-text-clip">
                    <input
                      type="radio"
                      name="is_self_pay"
                      value="false"
                      checked={formData.is_self_pay === false}
                      onChange={() =>
                        setFormData((prev) => ({ ...prev, is_self_pay: false }))
                      }
                    />
                    Self Directed
                  </label>
                </div>
              </div>

              <button
                type="submit"
                className="sign-in-button"
                disabled={loading}
              >
                {loading ? "Creating Your Account..." : "Create Your Account"}
              </button>
            </form>

            <hr />
            <div className="new-account">
              <p className="black-text-clip">Already Have An Account?</p>
              <Link className="create-account-button" to="/login">
                Log In To Your Account
              </Link>
            </div>
          </div>
        </div>

        <div className="cover-photo-banner-con">
          <div className="cover-photo-banner-ca">
            <img src={CoverPhoto} alt="Cover" className="cover-photo" />
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateAccount;
